var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 4.48602V1.49935C11.0007 0.766016 10.4007 0.166016 9.66732 0.166016H1.66732C0.933984 0.166016 0.333984 0.766016 0.333984 1.49935V9.49935C0.333984 10.2327 0.933984 10.8327 1.66732 10.8327H9.66732C10.4007 10.8327 11.0007 10.2327 11.0007 9.49935V6.51268L13.1006 8.59935C13.3073 8.81268 13.6673 8.65935 13.6673 8.36602V2.63268C13.6673 2.33935 13.3073 2.18602 13.1006 2.39935L11.0007 4.48602ZM5.66732 2.83268C6.40065 2.83268 7.00065 3.43268 7.00065 4.16602C7.00065 4.89935 6.40065 5.49935 5.66732 5.49935C4.93398 5.49935 4.33398 4.89935 4.33398 4.16602C4.33398 3.43268 4.93398 2.83268 5.66732 2.83268ZM8.33398 8.16602H3.00065V7.78602C3.00065 7.24602 3.32065 6.76602 3.81398 6.55268C4.39855 6.29756 5.0295 6.16587 5.66732 6.16587C6.30513 6.16587 6.93608 6.29756 7.52065 6.55268C7.76218 6.65592 7.96803 6.82786 8.11264 7.04714C8.25724 7.26641 8.33421 7.52335 8.33398 7.78602V8.16602Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraIcon);
export default __webpack_public_path__ + "static/media/video-camera-icon.937059eaa6c013c978308baea6ded0c5.svg";
export { ForwardRef as ReactComponent };